import { navigateToTeamsApp } from '@atlaskit/teams-app-config/utils/teams-app-navigation/navigate-to-teams-app';

import { COMPANY_HUB } from '@confluence/named-routes/entry-points/routes.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const useFallbackUrls = (): Record<string, string> => {
	const { cloudId, orgId } = useSessionData();
	const { href } = navigateToTeamsApp({
		type: 'LANDING',
		cloudId,
		orgId,
		userHasNav4Enabled: true,
	});
	return {
		companyHubShortcut: COMPANY_HUB.toUrl(),
		teamsShortcut: href,
	};
};
